import _ from "lodash";
import {
  getUpdateData,
  persistAddress,
  sanitizeAddressData,
  sanitizeOrganizationData,
  sanitizeOrganizationEmailData,
} from "./persisterService";
import ApiClient from "../ApiClient";
import { getProductData } from "../Product/ProductService/productService";
import { apiPatch } from "../Api/apiCall";
import { persistContractClaimSubEntities } from "./AbstractContractClaimPersister";
import { RentalContract } from "../../types/Products/RentalContract";
import { UseForm } from "../../types/UseForm";

export const persistRentalContractCase = async (
  updateData: UseForm["values"],
  origRentalContractCase: RentalContract
) => {
  await persistContractClaimSubEntities(updateData, origRentalContractCase);

  if (_.isObject(updateData.propertyAddress)) {
    const propertyAddressUpdateData = getUpdateData(
      updateData.propertyAddress,
      origRentalContractCase,
      "propertyAddress"
    );
    await persistAddress(origRentalContractCase.propertyAddress.id, sanitizeAddressData(propertyAddressUpdateData));
  }

  if (updateData.propertyManager) {
    const propertyManagerUpdateData = getUpdateData(
      updateData.propertyManager.organization,
      origRentalContractCase,
      "propertyManager.organization"
    );
    await ApiClient.patch(`organizations/${origRentalContractCase.propertyManager.organization.id}`, {
      body: JSON.stringify(sanitizeOrganizationData(propertyManagerUpdateData)),
    });
  }

  if (_.isObject(updateData.propertyManager?.organization.mainEmail)) {
    const propertyManagerEmailUpdateData = getUpdateData(
      updateData.propertyManager.organization.mainEmail,
      origRentalContractCase,
      "propertyManager.organization.mainEmail"
    );

    await ApiClient.patch(`organization_emails/${origRentalContractCase.propertyManager.organization.mainEmail.id}`, {
      body: JSON.stringify(sanitizeOrganizationEmailData(propertyManagerEmailUpdateData)),
    });
  }

  if (_.has(updateData, "propertyManager.organization.address") && updateData.propertyManager.organization.address) {
    const propertyManagerAddressUpdateData = getUpdateData(
      updateData.propertyManager.organization.address,
      origRentalContractCase,
      "propertyManager.organization.address"
    );
    await persistAddress(
      origRentalContractCase.propertyManager.organization.address.id,
      sanitizeAddressData(propertyManagerAddressUpdateData)
    );
  }

  if (_.isObject(updateData.contractualPartnerLegalEntity?.organization.mainEmail)) {
    const legalEntityEmailUpdateData = getUpdateData(
      updateData.contractualPartnerLegalEntity.organization.mainEmail,
      origRentalContractCase,
      "contractualPartnerLegalEntity.organization.mainEmail"
    );

    await ApiClient.patch(
      `organization_emails/${origRentalContractCase.contractualPartnerLegalEntity.organization.mainEmail.id}`,
      {
        body: JSON.stringify(sanitizeOrganizationEmailData(legalEntityEmailUpdateData)),
      }
    );
  }

  const apiUri = getProductData(origRentalContractCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origRentalContractCase);
  await apiPatch(apiUri, origRentalContractCase.id, contractCaseUpdateData);
};
